import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import axiosHttp from "services/axiosHttp";

//CREATE ACTION
export const dashboardUsersAssignee = createAsyncThunk("dashboardUsersAssignee", async ({ data }, { rejectWithValue }) => {
	try {
		const token = localStorage.getItem("auth_token");

		const config = {
			headers: {
				Authorization: `Bearer ${token}`,
				"Access-Control-Allow-Origin": "*",
				"Content-Type": "application/json",
				Accept: "application/json",
			},
		};
		const response = await axiosHttp.post(`analytics/dashboard/assignee`, data, config);
		message.success("Users are successfully assigned.!");
		return response.data;
	} catch (err) {
		if (!err.response) {
			throw err;
		}
		return rejectWithValue(err.response.data);
	}
});

const SubDashboardUserAssigneeSlice = createSlice({
	name: "SubDashboardUserAssigneeSlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
		data: null,
	},

	extraReducers: (builder) => {
		builder.addCase(dashboardUsersAssignee.pending, (state, action) => {
			state.isLoading = true;
			state.isError = false;
		});

		builder.addCase(dashboardUsersAssignee.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});

		builder.addCase(dashboardUsersAssignee.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload;
		});
	},
});

export default SubDashboardUserAssigneeSlice.reducer;
